import axios from './config';

export const getUser = ({ id, queryStr }) => {
  if (!id) return {};
  return axios.get(`/users/${id}?${queryStr}`).then(res => res.data);
};
